import {Component, Inject, OnInit} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {UserPickerComponent} from '../../shared/components/user-picker.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ReactiveFormsModule, UntypedFormControl, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {Moment} from 'moment';
import moment from 'moment-timezone';

@Component({
    selector: 'app-send-report-dialog',
    templateUrl: './send-report-dialog.component.html',
    standalone: true,
    imports: [
        MatDialogActions,
        MatDialogContent,
        UserPickerComponent,
        MatFormFieldModule,
        MatDatepickerModule,
        MatDialogTitle,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule
    ],
    providers: [
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
    ]
})
export class SendReportDialogComponent implements OnInit {

    public employee: UntypedFormControl = new UntypedFormControl(undefined, Validators.required);
    public reportDateControl: UntypedFormControl = new UntypedFormControl(undefined, Validators.required);
    public maxDate = new Date();

    public userReadOnly = false;

    constructor(
        public dialogRef: MatDialogRef<SendReportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        if (!this.data.canChangeUser) {
            this.employee.setValue(this.data.user);
            this.userReadOnly = true;
        } else {
            this.dateFilter = undefined;
        }
    }

    public dateFilter = (d: Moment | null): boolean => {
        if (!this.data.sentDates) {
            return false;
        }

        // the existingTimereportTs is CEST, the calendar's date is always midnight locale (so usually US or Italy).
        // Comparing timestamps is not enough, as the existingTimereportTs would be fine in italy and like 15:00 of day before in USA!
        // As we only care if its the same day, we force Rome timezone and then compare the day.
        for (const existingTimereportTs of this.data.sentDates as Set<number>) {
            console.log(moment(existingTimereportTs).toString(), moment.tz(existingTimereportTs, 'Europe/Rome').toString(), d.toString());
            if (moment.tz(existingTimereportTs, 'Europe/Rome').isSame(d, 'day')) return false;
        }
        return true;
        // previous solution ----> return !this.data.sentDates.has(d.valueOf());
    }

    closeDialog() {
        if (this.validateForm()) {
            const selectedDate: Moment = this.reportDateControl.value;
            this.dialogRef.close({
                user: this.data.canChangeUser ? this.employee.value : this.data.user,
                reportDate: moment.tz(selectedDate.format('YYYY-MM-DD'), 'Europe/Rome')
            });
        } else {
            console.log('Invalid');
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    private validateForm() {
        return this.reportDateControl.valid && (!this.data.canChangeUser || this.employee.valid);
    }

}
